import { normalizePrerenderPathname } from '../utils/prerenderRoutes';

export const BOOT_RECOVERY_WINDOW_MS = 15000;
const bootStartedAt = Date.now();
export const BOOT_RELOAD_SESSION_PREFIX = 'fide_boot_reload:';

export const isReactSnap = (windowObject = typeof window !== 'undefined' ? window : null) =>
  /ReactSnap/.test(windowObject?.navigator?.userAgent || '');

export const getBootStartedAt = () => bootStartedAt;

export const isBootWindowActive = ({
  now = Date.now(),
  startedAt = bootStartedAt,
  recoveryWindowMs = BOOT_RECOVERY_WINDOW_MS,
} = {}) => now - startedAt <= recoveryWindowMs;

export const getBootReloadSessionKey = (pathname = '') =>
  `${BOOT_RELOAD_SESSION_PREFIX}${normalizePrerenderPathname(pathname)}`;

export const tryBootReloadOnce = ({ pathname, storage, reload }) => {
  if (!storage || typeof storage.getItem !== 'function' || typeof storage.setItem !== 'function') {
    return false;
  }

  const key = getBootReloadSessionKey(pathname);
  try {
    if (storage.getItem(key) === '1') {
      return false;
    }

    storage.setItem(key, '1');
  } catch {
    return false;
  }
  reload();
  return true;
};

export const clearBootReloadMarker = ({ pathname, storage }) => {
  if (!storage || typeof storage.removeItem !== 'function') {
    return;
  }

  try {
    storage.removeItem(getBootReloadSessionKey(pathname));
  } catch {
    // Ignore storage failures; boot cleanup must not block fallback rendering.
  }
};

export const getBootErrorMessage = (error) =>
  typeof error === 'string'
    ? error
    : error?.message || error?.reason?.message || error?.error?.message || error?.toString?.() || '';

export const isChunkOrHydrationBootError = (error) => {
  const normalized = getBootErrorMessage(error).toLowerCase();
  if (!normalized) {
    return false;
  }

  return (
    normalized.includes('loading chunk') ||
    normalized.includes('chunkloaderror') ||
    normalized.includes('failed to fetch dynamically imported module') ||
    normalized.includes('importing a module script failed') ||
    normalized.includes('hydration') ||
    normalized.includes('hydrating') ||
    normalized.includes('there was an error while hydrating')
  );
};

export const logBootFailure = ({ error, pathname, source = 'boot' }) => {
  console.error(`[boot-recovery:${source}] ${normalizePrerenderPathname(pathname)}`, error);
};

export const getBootFallbackMessage = (pathname = '') =>
  `We could not finish loading ${normalizePrerenderPathname(pathname)}. Please try again.`;
